export const COOKIES_AUTH_TOKEN = '__1tm_token';
